import { SCREEN_PRESENTER } from '@studio/constants/Sources';
import { toggleProgramSource } from '@shoflo/studio-redux/actions';
import setProgram from './setProgram';
/**
 * Removes a screen share from the program/stage when it's stopped or deleted.
 * Uses toggleProgramSource to properly recalculate the scene layout.
 * @param {string} screenShareAttendeeId - The attendee ID of the screen share to remove (e.g., "user-123#content")
 * @returns {Function} Redux thunk function
 */
function removeScreenShareFromProgram(screenShareAttendeeId) {
  return (dispatch, getState) => {
    const { program, broadcastSources } = getState();

    if (!program || !program.layers) {
      return;
    }

    // Check if the screen share is currently on stage
    const screenShareLayer = program.layers.find(
      layer =>
        layer.source?.type === SCREEN_PRESENTER &&
        layer.source?.value === screenShareAttendeeId
    );

    if (!screenShareLayer) {
      return;
    }

    const source = broadcastSources.sources.find(
      s => s.value === screenShareAttendeeId
    );
    if (source) {
      dispatch(toggleProgramSource(source, setProgram));
    }
  };
}

export default removeScreenShareFromProgram;
